import { useSensors, useSensor, MouseSensor, TouchSensor, KeyboardSensor } from '@dnd-kit/core';

const useDragSensors = ({
  useGeneric,
  activationConstraint,
  coordinateGetter
}) => {
  return useSensors(useSensor(MouseSensor, useGeneric ? {} : {
    activationConstraint
  }), useSensor(TouchSensor, useGeneric ? {} : {
    activationConstraint
  }), useSensor(KeyboardSensor, useGeneric ? {} : {
    coordinateGetter
  }));
};

export { useDragSensors };
